import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'

export const useGetInvitationLink = () => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['invitationLink'],
    queryFn: () => usersService.getInvitationLink(),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar dados do link de convite',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      invitationLink: data,
      isLoading,
      refetchInvitationLink: refetch,
    }
  }

  return {
    invitationLink: null,
    isLoading,
    refetchInvitationLink: refetch,
  }
}
